const { log } = console
module.exports = function store (state, emitter) {
  emitter.on('set-fullscreen-flags', () => {
    log('set-fullscreen-flags')
    state.showGlitches = false
    state.spriteOperationsAllowed = true
    state.isFullscreen = true
  })
}
